import { useFela } from 'react-fela'
import { Style } from '../providers/style/types'
import classNames from 'classnames'

export const useGeneratedClassName = <Props>({
  style,
  className,
  ...props
}: { style?: Style | Array<Style>; className?: string } & Props) => {
  const { css } = useFela(props)

  // @ts-ignore
  return classNames(css(style), className)
}
